import Cookies from 'js-cookie';
// import nookies from 'nookies';
import {Language} from '../../../context/LanguageContext';
import {useCallback, useState} from 'react';
import {useUser} from '../../../hooks';
import {Close} from '@material-ui/icons';
import {APIURL} from '../../../consts';

export default function FormFolder({type, data, onClose}) {
  const tokens_session = Cookies.get('token');
  const {createDocumentation, updateDocumentation} = useUser();
  const {language, newObj} = Language();
  const [name, setName] = useState('');

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();
        if (type === 'add') {
          const {file, path, parentId, type} = data.selected;
          const formData = new FormData();
          formData.append('file', file);
          formData.append('name', name);
          formData.append('path', path);
          formData.append('parentId', parentId);
          formData.append('type', type);
          await createDocumentation(tokens_session, formData);
        } else {
          const {type, id} = data.selected;
          const formData = new FormData();
          formData.append('name', name);
          formData.append('type', type);
          formData.append('id', id);
          await updateDocumentation(tokens_session, formData);
        }
      } catch (error) {
      } finally {
        onClose();
      }
    },
    [tokens_session, type, language, data, name]
  );

  return (
    <div className='modal_content center add_folder'>
      <div className='modal_header'>
        <p className='modal_title'>
          {type === 'add'
            ? newObj.CreateFolderWord[language]
            : newObj.RenameWord[language]}
        </p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className='modal_body '>
        <form
          action='POST'
          className='add_folder_form'
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <div className='add_folder_input'>
            <input
              type='text'
              value={name}
              name='name'
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className='modal_flexible_btn_ctr'>
            <button type='submit'>{newObj.SaveWord[language]}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
